export default "__VITE_ASSET__36cb5ce4__"